<template>
  <div>
    <vxe-card size="mini" width="100%">
      <div slot="title">
        <vxe-button content="tab.replenishmentRule" mode="text" status="primary"/>
      </div>
      <div slot="extra">
        <vxe-button content="button.refresh" icon="vxe-icon-refresh" mode="text" status="danger" @click="fetch()"/>
        <vxe-button content="button.add" icon="vxe-icon-add" mode="text" status="primary" @click="add"/>
      </div>
      <vxe-table ref="table" :data="data" :loading="loading">
        <vxe-column fixed="left" type="seq" width="40"/>
        <vxe-column field="sourceStorageRoom.name" title="business.label.replenishSourceStorageRoom" width="200"/>
        <vxe-column field="times" title="business.label.obtainTimes" width="100"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="handover" title="business.label.handover" width="70"/>
        <vxe-column :cell-render="{name:'FormatSelect',options:transmissionTypes}" field="transmissionType" title="business.label.transmissionType"/>
        <vxe-column fixed="right" title="business.label.operate" width="auto">
          <vxe-button-group slot-scope="{row}" mode="text">
            <vxe-button content="button.edit" icon="vxe-icon-edit" status="primary" @click.stop="edit(row,false)"/>
            <vxe-button content="button.copy" icon="vxe-icon-copy" status="primary" @click.stop="edit(row,true)"/>
            <vxe-button content="button.delete" icon="vxe-icon-delete" status="danger" @click.stop="remove(row)"/>
          </vxe-button-group>
        </vxe-column>
      </vxe-table>
    </vxe-card>
    <replenishment-rule-editor ref="editor" :transmission-types="transmissionTypes" @success="fetch()"/>
  </div>
</template>

<script>
import { deleteOne, findAll } from '@/api/Api'
import { ReplenishmentRule } from '@/api/dto/config/ReplenishmentRule'
import { StorageRoom } from '@/api/dto/common/StorageRoom'
import ReplenishmentRuleEditor from '@/views/basedata/storageroom/ReplenishmentRuleEditor.vue'

export default {
  name: 'ReplenishmentRuleTable',
  components: { ReplenishmentRuleEditor },
  data() {
    return {
      loading: false,
      data: [],
      storageRoom: new StorageRoom()
    }
  },
  props: {
    transmissionTypes: {
      type: Array,
      default: []
    }
  },
  methods: {
    fetch(storageRoom) {
      this.loading = true
      if (storageRoom) {
        this.storageRoom = storageRoom
      }
      findAll('replenishmentRuleFactory', { 'targetStorageRoom.ids': [this.storageRoom.id] }).then(res => {
        if (res.success) {
          this.data = res.result.map(item => {
            return new ReplenishmentRule(item)
          })
        }
      }).finally(() => this.loading = false)
    },
    add() {
      this.$refs.editor.add(this.storageRoom)
    },
    edit(row) {
      this.$refs.editor.edit(row)
    },
    remove(row) {
      this.loading = true
      deleteOne('replenishmentRuleDeleter', { id: row.id }).then(res => {
        if (res.success) {
          this.$message.success(this.$t('message.deleteSuccess'))
          this.fetch()
        }
      }).finally(() => this.loading = false)
    }
  }
}
</script>